import xeModalSelf from "./xeModalSelf.vue";

export default {
    props: ["initSetting"],
    components: {
        xeModalSelf,
    },
    data() {
        return {
            copySetting: {},
            isSelfSearch: false,
        };
    },
    computed: {},
    watch: {},
    created() {
        console.log("xeBaseSetting created", this.initSetting);
        this.copySetting = JSON.parse(JSON.stringify(this.initSetting));
        
        // chart 기본 구조 초기화
        if (!this.copySetting.chart) {
            this.copySetting.chart = {};
        }
        
        // chart 기본 속성들
        if (!this.copySetting.chart.backgroundColor) {
            this.copySetting.chart.backgroundColor = "#ffffff";
        }
        if (!this.copySetting.chart.gridColor) {
            this.copySetting.chart.gridColor = "#e0e0e0";
        }
        if (!this.copySetting.chart.fontColor) {
            this.copySetting.chart.fontColor = "#000000";
        }
        if (!this.copySetting.chart.chartFontSize) {
            this.copySetting.chart.chartFontSize = 12;
        }
        
        // series 초기화
        if (!this.copySetting.chart.series) {
            this.copySetting.chart.series = [];
        }
        
        // 기존 series에 label이 없으면 기본값 추가
        this.copySetting.chart.series.forEach((series, index) => {
            if (!series.label) {
                series.label = `Default ${index + 1}`;
            }
        });
        
        // options 구조 초기화
        if (!this.copySetting.chart.options) {
            this.copySetting.chart.options = {};
        }
        
        // legend 구조 초기화
        if (!this.copySetting.chart.options.legend) {
            this.copySetting.chart.options.legend = {
                display: true,
                position: "top",
                align: "center",
                labels: {
                    fontSize: 12,
                    fontColor: "#000000"
                }
            };
        }
        if (!this.copySetting.chart.options.legend.labels) {
            this.copySetting.chart.options.legend.labels = {
                fontSize: 12,
                fontColor: "#000000"
            };
        }
        
        // yAxes 구조 초기화
        if (!this.copySetting.chart.options.yAxes) {
            this.copySetting.chart.options.yAxes = {
                left: {
                    display: true,
                    label: "",
                    unit: "",
                    fontColor: "#000000",
                    fontSize: 12
                },
                right: {
                    display: false,
                    label: "",
                    unit: "",
                    fontColor: "#000000",
                    fontSize: 12
                }
            };
        }
        if (!this.copySetting.chart.options.yAxes.left) {
            this.copySetting.chart.options.yAxes.left = {
                display: true,
                label: "",
                unit: "",
                fontColor: "#000000",
                fontSize: 12
            };
        }
        if (!this.copySetting.chart.options.yAxes.right) {
            this.copySetting.chart.options.yAxes.right = {
                display: false,
                label: "",
                unit: "",
                fontColor: "#000000",
                fontSize: 12
            };
        }
        
        // addition 구조 초기화
        if (!this.copySetting.addition) {
            this.copySetting.addition = {
                fixed: 0,
                afterAction: "",
                afterBind: "Last"
            };
        }
        
        // self 구조 초기화 (조회기간 설정)
        if (!this.copySetting.self) {
            this.copySetting.self = {
                baseline: {
                    type: 3,
                    sTi: "",
                    eTi: ""
                },
                compare: {
                    type: 3,
                    sTi: "",
                    eTi: ""
                }
            };
        }
        if (!this.copySetting.self.baseline) {
            this.copySetting.self.baseline = {
                type: 3,
                sTi: "",
                eTi: ""
            };
        }
        if (!this.copySetting.self.compare) {
            this.copySetting.self.compare = {
                type: 3,
                sTi: "",
                eTi: ""
            };
        }
        
        this.isSelfSearch = this.copySetting.self ? true : false;
    },
    methods: {
        validFailed(errors) {
            let keys = Object.keys(errors);

            for (let i = 0; i < keys.length; i++) {
                let message = errors[keys[i]][0];

                if (message !== "") {
                    this.alertNoti(`${keys[i]}는 ${message}`);
                    return;
                }
            }

            // console.log(value);
        },

        async onModalOK() {
            this.copySetting.chart?.series?.forEach((item) => {
                const find = this.searchPoint?.find((point) => point.pointList.some((pt) => pt.ptAddr === item.point));
                const findPoint = find?.pointList?.find((pt) => pt.ptAddr == item.point);
                if (!this.isEmpty(findPoint)) item.unit = findPoint.unit;
            });
            await this.$emit("on-modal-ok", this.copySetting);
        },
        onModalCancel() {
            this.copySetting = JSON.parse(JSON.stringify(this.initSetting));
            this.$emit("on-modal-cancel");
        },
    },
};
